module.exports = __webpack_public_path__ + "static/media/SpenLeaf-4.3ff34a1c.webp";